<div class="wrapper">
  <conversation-resolver (resolveConversation)="resolveConversation($event)" [disabled]="!!conversation?.resolvedAt" buttonClass="p-button-success p-button-left-aligned p-button-fullwidth"></conversation-resolver>
</div>
